import {
  SHOW_CREATE_TSV_MODAL,
  HIDE_CREATE_TSV_MODAL,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isVisible: false,
    isLoading: false,
  };
};

const initialState = getInitialState();

const createTsvModal = (state = initialState, action) => {
  const types = {
    [SHOW_CREATE_TSV_MODAL]: () => ({
      ...state,
      isVisible: true,
    }),
    [HIDE_CREATE_TSV_MODAL]: () => initialState,
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default createTsvModal;
